// extracted by mini-css-extract-plugin
module.exports = {"DisconnectedModal":"styles_DisconnectedModal__2AzYv","Title":"styles_Title__1Qh4t","NoteTitle":"styles_NoteTitle__2Epw-","Done":"styles_Done__sys6I"};